import React from 'react';
import Avatar, { type AvatarPropTypes } from '@atlaskit/avatar';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl/src';
import { UNASSIGNED_ID } from '@atlassian/jira-issue-field-assignee/src/common/constants.tsx';
import type { UserValue } from '@atlassian/jira-issue-field-assignee/src/common/types.tsx';
import { getUserAvatarUrl } from '@atlassian/jira-issue-field-assignee/src/common/utils.tsx';
import tooltipMessages from '@atlassian/jira-issue-field-assignee/src/common/ui/read-view/popover/messages.tsx';
import messages from '@atlassian/jira-issue-field-assignee/src/messages.tsx';

export type AssigneeAvatarProps = {
	value?: UserValue;
	isOpen?: boolean;
	iconSize?: AvatarPropTypes['size'];
};

export const AssigneeAvatar = ({ value, iconSize = 'xsmall' }: AssigneeAvatarProps) => {
	const { formatMessage } = useIntl();

	const unassignedUser = {
		accountId: UNASSIGNED_ID,
		displayName: formatMessage(messages.unassignedOption),
		avatarUrls: {},
	};

	const user = value || unassignedUser;
	const assigneeName =
		user.accountId === UNASSIGNED_ID
			? user.displayName
			: formatMessage(tooltipMessages.assigneeTooltip, {
					name: user.displayName,
				});
	const avatarUrl = getUserAvatarUrl(user);

	return (
		<Tooltip content={assigneeName} hideTooltipOnMouseDown>
			<Avatar
				testId="inline-assignee-picker.assignee-picker-popup.assignee-avatar.avatar"
				size={iconSize}
				src={avatarUrl}
				name={assigneeName}
				borderColor="transparent"
			/>
		</Tooltip>
	);
};
